import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager } from "../../../../utils";

export const addDistrict = createAsyncThunk('addDistrict', async (data) => {

    try {
        const res = await axios({

            method: 'POST',
            url: process.env.REACT_APP_API_URL + 'district',
            data: {
                "state_id": data?.values?.state,
                "district_name": data?.values?.districtName,
                "status": data?.values?.status,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})